import { atom } from "recoil";

import keys from "./constants";

export const isBannerPriceModalOpenedState = atom<boolean>({
  key: keys.IS_BANNER_PRICE_MODAL_OPENED_STATE,
  default: false
});

export const bannerSelectedProductState = atom<any>({
  key: keys.BANNER_SELECTED_PRODUCT_STATE,
  default: null
});

export const isBannerAddingModalAddingState = atom<boolean>({
  key: keys.IS_BANNER_MODAL_ADDING_STATE,
  default: false
});
